// extracted by mini-css-extract-plugin
export default {"form":"VTRAFx2","relatedCampaigns":"wKGpI8W","relatedList":"GE5rjkt","relatedTitle":"K4S590c","w100":"ZINMk1Z"};